export default __webpack_public_path__ + "static/launch-a9dd4fcb9488fd562168296f23fd8fcb.jpg";